export enum EstadoFiltro {
  Habilitado = 0,
  Bloqueado = 1,
  Excedido = 2,
  Vencido = 3,
  ExcedidoVencido = 4
}
